import { render, staticRenderFns } from "./TableButton.vue?vue&type=template&id=19b59e10&scoped=true&"
import script from "./TableButton.vue?vue&type=script&lang=js&"
export * from "./TableButton.vue?vue&type=script&lang=js&"
import style0 from "./TableButton.vue?vue&type=style&index=0&id=19b59e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b59e10",
  null
  
)

export default component.exports